/** Normalized backoffice origin (no trailing slash). */
export function normalizeBackofficeBase(
  raw: string | undefined,
  fallback: string,
): string {
  return (raw || fallback).replace(/\/$/, '')
}

/** next.config.js parity: /admin → /explore, /admin/x → /explore/x */
export function adminRedirectTarget(
  pathname: string,
  backofficeBase: string,
): string {
  const bo = normalizeBackofficeBase(backofficeBase, 'http://localhost:3010')
  const rest = pathname === '/admin' ? '' : pathname.slice('/admin'.length)
  return `${bo}/explore${rest}`
}

/** next.config.js parity: /internal/kitchen-sink → /explore/kitchen-sink */
export function kitchenSinkRedirectTarget(
  pathname: string,
  backofficeBase: string,
): string {
  const bo = normalizeBackofficeBase(backofficeBase, 'http://localhost:3010')
  const prefix = '/internal/kitchen-sink'
  const rest =
    pathname === prefix ? '' : pathname.slice(prefix.length)
  return `${bo}/explore/kitchen-sink${rest}`
}
